import Decimal from 'decimal.js';

export const DEC_PRECISION = 18;
const _Dec = Decimal.clone();

export interface Numeric<T> {
  add(other: any): T;

  sub(other: any): T;

  mul(other: any): T;

  div(other: any): T;

  mod(other: any): T;
}

_Dec.prototype.toString = function (): string {
  return this.toFixed(DEC_PRECISION);
};

export namespace Numeric {
  export type Input = Decimal.Value;
  export type Output = Int | Dec;

  export function parse(value: Input): Output {
    if (value instanceof Dec) {
      return value;
    } else if (typeof value === 'string') {
      if (value.includes('.')) {
        return new Dec(value);
      } else {
        return new Int(value);
      }
    } else {
      const _value = new Decimal(value);
      if (_value.isInteger()) {
        return new Int(_value);
      } else {
        return new Dec(_value.toString());
      }
    }
  }
}
export class Dec extends _Dec implements Numeric<Dec> {
  constructor(arg: Numeric.Input) {
    super(arg.toString());
  }

  public static withPrec(value: Decimal.Value, prec: number): Dec {
    return new Dec(new Dec(value).div(Math.pow(10, prec)));
  }

  // type conversion
  public toInt(): Int {
    return new Int(this);
  }

  // arithmetic

  public add(other: Numeric.Input): Dec {
    const val = new Dec(Numeric.parse(other));
    return new Dec(super.add(val));
  }

  public sub(other: Numeric.Input): Dec {
    const val = new Dec(Numeric.parse(other));
    return new Dec(super.sub(val));
  }

  public mul(other: Numeric.Input): Dec {
    const val = new Dec(Numeric.parse(other));
    return new Dec(super.mul(val));
  }

  public div(other: Numeric.Input): Dec {
    const val = new Dec(Numeric.parse(other));
    return new Dec(super.div(val));
  }

  public mod(other: Numeric.Input): Dec {
    const val = new Dec(Numeric.parse(other));
    return new Dec(super.mod(val));
  }
}

const _Int = Decimal.clone();

export class Int extends _Int implements Numeric<Numeric.Output> {
  constructor(arg: Numeric.Input) {
    const _arg = new Decimal(arg.toString());
    super(_arg.divToInt(1));
  }

  public toString(): string {
    return this.toFixed();
  }

  // type conversion
  public toDec(): Dec {
    return new Dec(this);
  }

  // artihmetic

  public add(other: Numeric.Input): Numeric.Output {
    const val = Numeric.parse(other);
    if (val instanceof Dec) {
      return new Dec(this).add(val);
    } else {
      return new Int(this.plus(val));
    }
  }

  public sub(other: Numeric.Input): Numeric.Output {
    const val = Numeric.parse(other);
    if (val instanceof Dec) {
      return new Dec(this).sub(val);
    } else {
      return new Int(this.minus(val));
    }
  }

  public mul(other: Numeric.Input): Numeric.Output {
    const val = Numeric.parse(other);
    if (val instanceof Dec) {
      return new Dec(this).mul(val);
    } else {
      return new Int(this.times(val));
    }
  }

  public div(other: Numeric.Input): Numeric.Output {
    const val = Numeric.parse(other);
    if (val instanceof Dec) {
      return new Dec(this).div(val);
    } else {
      return new Int(super.div(val));
    }
  }

  public mod(other: Numeric.Input): Numeric.Output {
    const val = Numeric.parse(other);
    if (val instanceof Dec) {
      return new Dec(this).mod(val);
    } else {
      return new Int(super.mod(val));
    }
  }
}
